import { styled } from 'styled-components'
import { FooterContainer } from 'todistukset-ui/src/vtj/components/footer/Footer.sc'

export const AppContainerBase = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  ${FooterContainer} {
    margin-top: ${({ theme }) => theme.spacing.xxl};
  }

  @media print {
    display: block;
  }
`
